'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FilterItem = function (_React$Component) {
  (0, _inherits3.default)(FilterItem, _React$Component);

  function FilterItem() {
    (0, _classCallCheck3.default)(this, FilterItem);
    return (0, _possibleConstructorReturn3.default)(this, (FilterItem.__proto__ || (0, _getPrototypeOf2.default)(FilterItem)).apply(this, arguments));
  }

  (0, _createClass3.default)(FilterItem, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        this.props.children
      );
    }
  }]);
  return FilterItem;
}(_react2.default.Component);

FilterItem.propTypes = {
  title: _propTypes2.default.string,
  valuePlaceholder: _propTypes2.default.string
};
FilterItem.defaultProps = {
  title: null,
  valuePlaceholder: null
};
exports.default = FilterItem;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-inter-dialog@0.0.46@@alicd/crui-inter-dialog/lib/Filter/FilterItem.js
// module id = 641
// module chunks = 0